import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect, useContext } from 'react'
import { createRecurrences, getExportData } from '../utilities/general-utils'
import TransactionItems from '../components/TransactionItem/TransactionItems'
import LoadingSpinner from '../components/ui/LoadingSpinner'
import FiltersHeader from '../components/FiltersHeader/FiltersHeader'
import { InputVarsContext } from '../contexts/input-vars-context'
import { svc_getTransactions, svc_getExceptions } from "../services/transaction.service";
import { IconCaution } from "../assets/icons";

function ManageExceptions() {
    const { getAccessTokenSilently, user } = useAuth0();
    const { vars } = useContext(InputVarsContext)
    const [isLoading, setIsLoading] = useState(false)
    const [exportData, setExportData] = useState(null)
    const [transactionsList, setTransactionsList] = useState(null)

    const resetData = async () => {
        setExportData(null)
        setTransactionsList(null)
    }

    const getData = async () => {
        const transactions = await getTransactions();

        setExportData(getExportData(transactions))
        setIsLoading(false)
    }

    const getTransactions = async () => {
        const accessToken = await getAccessTokenSilently();

        const {
            data: transactions
        } = await svc_getTransactions(
            accessToken,
            user.sub,
            vars.dateRange.startDate,
            vars.dateRange.endDate
        );

        const {
            data: exceptions
        } = await svc_getExceptions(
            accessToken,
            user.sub
        );

        let recurrences = []

        if (transactions && transactions.length > 0) {
            recurrences = createRecurrences(
                transactions,
                exceptions,
                vars.dateRange.startDate,
                vars.dateRange.endDate,
                null,
                true
            )
        }

        setTransactionsList(recurrences)

        return recurrences
    }

    useEffect(() => {
        const dataReady = exportData

        if (vars.dateRange.startDate && vars.dateRange.endDate && !dataReady && !isLoading) {
            setIsLoading(true)
            getData()
        }
    }, [
        isLoading,
        vars.dateRange.startDate,
        vars.dateRange.endDate,
        exportData,
        getData
    ])

    return (
        <div className="content-width-container--slim">
            <div className="text-center">
                <h1>Manage Exceptions</h1>
                <p>
                    This page shows all transaction instances that you have modified in some way, such as the amount, marking it as paid or cancelled, or rescheduling it to occur on a different date.
                </p>
                <p>
                    <strong>NOTE:</strong> You can add multiple exceptions to the same transaction instance, and the most recent exception will be the one that is applied to the transaction. For example, if you created an exception to modify the amount from $100 to $50, and then created another exception to modify the amount from $50 to $25, the transaction will be modified to have an amount of $25.
                </p>
                <p>
                    Click on the <IconCaution /> icon to view the details of the exception(s).
                </p>
            </div>

            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {transactionsList && (
                        <TransactionItems
                            items={transactionsList}
                            hideBalance={true}
                            exportData={exportData}
                            preSelectAll={true}
                            FiltersHeader={<ExceptionsFilterHeader isLoading={isLoading} resetData={resetData} />}
                        />
                    )}
                </>
            )}
        </div>
    )
}

const ExceptionsFilterHeader = ({
    isLoading,
    resetData
}) => {
    return (
        <div className="standardFormWrap">
            <FiltersHeader
                isLoading={isLoading}
                hideActiveFundsWidget={true}
                onStartDateChange={resetData}
                onEndDateChange={resetData}
            />
        </div>
    )
}

export default ManageExceptions
